"use strict";import{IconChevron75 as e}from"../src/elements/IconChevron75.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon-chevron75",e);
//# sourceMappingURL=sp-icon-chevron75.js.map
